<template>
  <Layout tituloPagina="Hotspot | Layouts | Portal cautivo">
    <div class="card">
      <!-- Nav tabs -->
      <ul class="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            data-bs-toggle="tab"
            href="#portal"
            role="tab"
          >
            <i class="bx bx-layout font-size-20"></i>
            <span class="d-none d-sm-block">
              Layout de portal cautivo
            </span>
          </a>
        </li>
        <li class="nav-item">
          <router-link :to="{ name:'fichasLayoutHotspot'}" class="nav-link">
            <i class="bx bx-receipt font-size-20"></i>
            <span class="d-none d-sm-block">
              Layout de fichas
            </span>
          </router-link>
        </li>
        <li class="nav-item"></li>
        <li class="nav-item"></li>
        <li class="nav-item"></li>
      </ul>
      <!-- Tab content -->
      <div class="tab-content p-4">
        <div class="tab-pane active" id="portal" role="tabpanel">
          <div class="row">
            <div class="offset-md-2 col-md-8 col-9 mb-3">
              <filtrador
                v-on:dato-actualizado="
                  dato = $event,
                  refrescarPortalesCautivos()
                "
                :datoini="dato"
                placeholder="Dato del portal cautivo"
              ></filtrador>
            </div>
            <div class="col-md-2 col-3 text-right">
              <router-link :to="{ name: 'nuevoPortalCautivoHotspot' }" class="btn btn-success">
                <span class="d-none d-sm-block">
                  <i class="mdi mdi-plus-thick"></i>
                  Nuevo portal
                </span>
                <span class="d-block d-sm-none">
                  <i class="mdi mdi-plus-thick"></i>
                </span>
              </router-link>
            </div>
          </div>
          <br>
          <div class="row" style="min-height: 475px;" >
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table table-hover table-nowrap align-middle" id="tabla-portal-cautivo">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Fecha de creación</th>
                      <th>Ultima edición</th>
                      <th>Tipo de autenticación</th>
                      <th style="width:180px" class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(portal,index) in portales_cautivos" :key="`portal-${index++}`">
                      <td class="fw-semibold">{{portal.id}}</td>
                      <td>
                        {{portal.nombre}}
                      </td>
                      <td>
                        {{formatoFecha(portal.created_at)}}
                      </td>
                      <td>
                        {{formatoFecha(portal.updated_at)}}
                      </td>
                      <td>
                        <span
                          :class="{
                            'text-success' : portal.tipo_autenticacion == 1,
                            'text-info' : portal.tipo_autenticacion == 2
                          }"
                        >
                          <strong>
                            {{portal.tipo_autenticacion == 1 ? 'Solo PIN':'Usuario y contraseña'}}
                          </strong>
                        </span>
                      </td>
                      <td class="text-center">
                        <router-link
                          :to="{ name: 'edicionPortalCautivoHotspot', params: { id: portal.id } }"
                          class="btn btn-warning btn-sm"
                        >
                          <i class="mdi mdi-content-save-edit-outline"></i>
                          Editar
                        </router-link>
                        <button class="btn btn-danger btn-sm" @click="preguntaBorrarPortal(portal)">
                          <i class="mdi mdi-trash-can-outline"></i>
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="text-center">
            <paginador
              :pag="page"
              :totpag="totpag"
              :epp="epp"
              @cargar-pagina="cargarPagina"
              @epp-actualizado="
                epp = $event,
                refrescarPortalesCautivos()
              "
            ></paginador>
          </div>
        </div>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import PortalCautivoSrv from '@/services/hotspot/PortalCautivoSrv.js'
import Filtrador from '@/components/Filtrador.vue'
import Paginador from '@/components/Paginador.vue'
import Layout from "@/views/layouts/main"
import Swal from 'sweetalert2'
import moment from 'moment'

export default {
  name: 'ListadoPortalCautivoHotspot',
  components: { Layout, Filtrador, Paginador },
  data() {
    return {
      dato: '',
      page: 1,
      epp: parseInt(localStorage.getItem('argusblack.listadoPortalCautivoHotspot.por_pagina') || 10),
      tc: 0, // Total de portales cautivos
      totpag: 0, // Total de páginas
      portales_cautivos: []
    }
  },

  created() {
    var self = this

    if (self.$route.query.dato) self.dato = self.$route.query.dato
    if (self.$route.query.page) self.page = parseInt(self.$route.query.page)
    if (self.$route.query.epp)  self.epp  = parseInt(self.$route.query.epp)

    self.refrescarPortalesCautivos()
  },

  methods: {
    cargarPagina: function(n) {
      var self = this
      self.page = n
      self.refrescarPortalesCautivos({ page: n })
    },

    formatoFecha(mt) {
      return moment(mt, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
    },

    refrescarPortalesCautivos: function() {
      var self = this

      iu.spinner.mostrar('#tabla-portal-cautivo')

      this.$router.replace({
        query: {
          dato: self.dato,
          page: self.page,
          epp: self.epp
        }
      }).catch(error => {})

      let params = {
        page: self.page,
        epp: self.epp,
        dato: self.dato
      }
      
      PortalCautivoSrv.portalesJSON(params).then(response => {
        localStorage.setItem('argusblack.listadoPortalCautivoHotspot.por_pagina', self.epp)
        let page = response.data
        self.portales_cautivos = page.data
        self.tc = page.total
        self.totpag = page.last_page

        if (self.totpag < self.page) {
          self.page = self.totpag
          self.refrescarPortalesCautivos()
        }
      }).catch(error => {
        let mensaje = error.response.data.message || 'No se pudieron cargar los portales cautivos'
        iu.msg.error(mensaje)
        console.log(error)
      }).finally (() => {
        iu.spinner.ocultar('#tabla-portal-cautivo')
      })
    },

    preguntaBorrarPortal: function(portal){
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      })

      swal.fire({
        title: "¿Eliminar portal cautivo?",
        html: "¿Está seguro de eliminar el portal cautivo <br><b>"+portal.nombre+"</b>?",
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          PortalCautivoSrv.eliminar(portal.id).then(response => {
            swal.fire("Eliminado!", "Portal cautivo "+portal.nombre+" eliminado.", "success");
            self.refrescarPortalesCautivos()
          }).catch(error => {
            let mensaje
            try {
              mensaje = error.response.data.message
            } catch (e) {
              mensaje = "No se pudo eliminar el portal cautivo"+portal.nombre
            }
            iu.msg.error(mensaje)
            console.log(error)
          })
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    }
  },
  mounted: function() {
    iu.spinner.mostrar('#tabla-portal-cautivo')
  }
}
</script>
